// --------------------------------------------------
// Swiper config — no loop, peek carousel
// --------------------------------------------------
const swiper = new Swiper("#peekSwiper", {
  slidesPerView: 1.15,
  spaceBetween: 24,
  loop: false,
  allowTouchMove: true,
  centeredSlides: false,
  breakpoints: {
    768: { slidesPerView: 1.6, spaceBetween: 28 },
    992: { slidesPerView: 2.1, spaceBetween: 32 },
    1400: { slidesPerView: 2.2, spaceBetween: 36 },
  },
});

const prevBtn = document.getElementById("btnPrev");
const nextBtn = document.getElementById("btnNext");

function updateButtons() {
  prevBtn.disabled = swiper.isBeginning;
  nextBtn.disabled = swiper.isEnd;
}

updateButtons();
swiper.on("slideChange", updateButtons);
swiper.on("reachBeginning", updateButtons);
swiper.on("reachEnd", updateButtons);

prevBtn.addEventListener("click", () => swiper.slidePrev());
nextBtn.addEventListener("click", () => swiper.slideNext());

// --------------------------------------------------
// FAQ accordion open/close icon handling
// --------------------------------------------------
const items = document.querySelectorAll(".faq-item");

items.forEach((item) => {
  const target = item.getAttribute("data-bs-target");
  const collapseEl = document.querySelector(target);

  collapseEl.addEventListener("show.bs.collapse", () => {
    item.classList.add("open");
  });

  collapseEl.addEventListener("hide.bs.collapse", () => {
    item.classList.remove("open");
  });

  if (collapseEl.classList.contains("show")) {
    item.classList.add("open");
  }
});

// --------------------------------------------------
// Product Thumbnail logic
// --------------------------------------------------
const mainImage = document.querySelector(".main-tool-img");
const thumbs = document.querySelectorAll(".thumb");

if (mainImage && thumbs.length > 0) {
  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", function () {
      // Remove active class from all
      thumbs.forEach((t) => t.classList.remove("active"));

      // Add active to clicked
      this.classList.add("active");

      // Update main image src
      const newSrc = this.querySelector("img").src;
      mainImage.src = newSrc;
    });
  });
}

// // --------------------------------------------------
// // Price Update Counter & Real-time Cart Sync
// // --------------------------------------------------
// jQuery(document).ready(function ($) {
//   const basePrice = 869; // Default product price
//   const $totalDisplay = $('.total-price');
//   const mainProductId = $('input[name="main_product_id"]').val();
//   const storageKey = 'big_chooch_selected_addons';

//   // Load saved selections from localStorage or Sync with Server Cart
//   function loadSavedState() {
//     // Reset all first to ensure clean state
//     $('.addon-checkbox').prop('checked', false);

//     const cartItemIds = BigChoochAjax.cart_item_ids || [];
//     // Convert IDs to strings for robust comparison
//     const cartItemIdsString = cartItemIds.map(String);
//     const mainIdString = mainProductId.toString();

//     // Condition 1: Main Product is in Cart -> Sync Page to Cart (Server Truth)
//     if (cartItemIdsString.includes(mainIdString)) {
//       $('.addon-checkbox').each(function () {
//         if (cartItemIdsString.includes($(this).val())) {
//           $(this).prop('checked', true);
//         }
//       });
//     } 
//     // Condition 2: Main Product NOT in Cart -> Load from LocalStorage (User Preference/Draft)
//     else {
//       const savedAddons = JSON.parse(localStorage.getItem(storageKey));
//       if (savedAddons && Array.isArray(savedAddons)) {
//         $('.addon-checkbox').each(function () {
//           if (savedAddons.includes($(this).val())) {
//             $(this).prop('checked', true);
//           }
//         });
//       }
//     }

//     // Update totals and re-save to localStorage to keep everything in sync
//     updatePriceDisplay();
//   }

//   // Function to update the price display
//   function updatePriceDisplay() {
//     let total = basePrice;
//     const selectedAddons = [];

//     $('.addon-checkbox:checked').each(function () {
//       total += parseFloat($(this).data('price'));
//       selectedAddons.push($(this).val());
//     });

//     localStorage.setItem(storageKey, JSON.stringify(selectedAddons));

//     // Update cart count visually (1 main product + selected addons)
// 	// const count = 1 + selectedAddons.length;
// 	// $('.cart-quantity').text(count);
// 	// Removed to update only when the PRE-ORDER Button is Clicked!

//     $totalDisplay.html('$' + total.toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }) + ' <small>Charged in USD</small>');
//   }

//   // Load saved state on startup
//   loadSavedState();

//   // Function to fetch fresh cart state (handles "Back" button navigation)
//   function fetchFreshCartState() {
//     $.ajax({
//       url: BigChoochAjax.ajaxUrl,
//       type: 'POST',
//       data: {
//         action: 'big_chooch_get_cart_state',
//       },
//       success: function (response) {
//         if (response.success) {
//           // Update the global state with fresh data
//           BigChoochAjax.cart_item_ids = response.data.cart_item_ids;
//           // Re-run the logic to sync checkboxes
//           loadSavedState();
//         }
//       }
//     });
//   }

//   // Detect navigation back to this page (bfcache)
//   window.addEventListener('pageshow', function (event) {
//     // Always fetch fresh state to be safe
//     fetchFreshCartState();
//   });

//   // Handle addon checkbox changes
//   $('.addon-checkbox').on('change', function () {
//     // Update price display
//     updatePriceDisplay();
//   });

//   // Handle form submission
//   const checkoutForm = document.querySelector('#checkout form');
//   if (checkoutForm) {
//     checkoutForm.addEventListener('submit', function (e) {
//       e.preventDefault();

//       const selectedAddons = [];
//       document.querySelectorAll('.addon-checkbox:checked').forEach(cb => {
//         selectedAddons.push(cb.value);
//       });

//       $.ajax({
//         url: BigChoochAjax.ajaxUrl,
//         type: 'POST',
//         data: {
//           action: 'big_chooch_update_cart',
//           nonce: BigChoochAjax.nonce,
//           main_product_id: mainProductId,
//           addon_ids: selectedAddons
//         },
//         success: function (response) {
//           if (response.success) {
//             // Redirect to checkout
//             window.location.href = response.data.cart_url;
//           }
//         },
//         error: function () {
//           alert('Error updating cart. Please try again.');
//         }
//       });
//     });
//   }
// });